<template>
  <div class="mod-distwithdraw">
    <el-form
      :inline="true"
      :model="searchForm"
      @keyup.enter.native="getDataList()"
    >
      <el-form-item>
        <el-input
          v-model="searchForm.nickname"
          placeholder="用户昵称"
          clearable
        />
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="searchForm.withdrawType"
          clearable
          placeholder="提现类型"
        >
          <el-option key="1" label="零钱" value="1" />
          <el-option key="2" label="银行卡" value="2" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="searchForm.auditStatus"
          clearable
          placeholder="审核状态"
        >
          <el-option key="1" label="待审核" value="0" />
          <el-option key="2" label="审核通过" value="1" />
          <el-option key="3" label="审核不通过" value="2" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="searchForm.bankName"
          placeholder="银行名称"
          clearable
        />
      </el-form-item>
      <!--      <el-form-item>-->
      <!--        <el-input v-model="searchForm.cardId" placeholder="用户银行卡ID" clearable></el-input>-->
      <!--      </el-form-item>-->
      <el-form-item>
        <el-button @click="getDataList()"> 查询 </el-button>
        <!--        <el-button v-if="isAuth('mall:distwithdraw:delete')" type="danger" @click="deleteHandle()" :disabled="dataListSelections.length <= 0">批量删除</el-button>-->
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      border
      style="width: 100%"
      @selection-change="selectionChangeHandle"
    >
      <el-table-column
        type="selection"
        header-align="center"
        align="center"
        width="50"
      />
      <el-table-column
        prop="nickname"
        header-align="center"
        align="center"
        label="用户昵称"
      />
      <el-table-column
        prop="withdrawType"
        header-align="center"
        align="center"
        label="提现类型"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.withdrawType === 1"
            size="small"
            type="success"
          >
            零钱
          </el-tag>
          <el-tag
            v-else-if="scope.row.withdrawType === 2"
            size="small"
            type="warning"
          >
            银行卡
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="withdrawAmount"
        header-align="center"
        align="center"
        label="提现金额"
      />
      <el-table-column
        prop="withdrawFee"
        header-align="center"
        align="center"
        label="提现手续费"
      />
      <el-table-column
        prop="withdrawTime"
        header-align="center"
        align="center"
        label="提现时间"
      />
      <el-table-column
        prop="auditStatus"
        header-align="center"
        align="center"
        label="审核状态"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.auditStatus === 1"
            size="small"
            type="success"
          >
            审核通过
          </el-tag>
          <el-tag
            v-else-if="scope.row.auditStatus === 2"
            size="small"
            type="danger"
          >
            审核不通过
          </el-tag>
          <template v-else>
            <el-tag size="small" type="default"> 待审核 </el-tag>
            <el-button
              v-if="isAuth('mall:distwithdraw:confirmAudit')"
              type="success"
              size="mini"
              @click="confirmAudit(scope.row.id, 'AUDIT_PASSED')"
            >
              通过
            </el-button>
            <el-button
              v-if="isAuth('mall:distwithdraw:confirmAudit')"
              type="danger"
              size="mini"
              @click="confirmAudit(scope.row.id, 'AUDIT_NOT_PASSED')"
            >
              不通过
            </el-button>
          </template>
        </template>
      </el-table-column>
      <el-table-column
        prop="cardNumber"
        header-align="center"
        align="center"
        label="银行卡号"
      />
      <el-table-column
        prop="cardType"
        header-align="center"
        align="center"
        label="银行卡类型"
      />
      <el-table-column
        prop="bankName"
        header-align="center"
        align="center"
        label="银行名称"
      />
      <el-table-column
        fixed="right"
        header-align="center"
        align="center"
        width="150"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button
            v-if="isAuth('mall:distwithdraw:info')"
            type="text"
            size="small"
            @click="showDetails(scope.row.id)"
          >
            查看
          </el-button>
          <el-button
            v-if="isAuth('mall:distwithdraw:update')"
            type="text"
            size="small"
            @click="addOrUpdateHandle(scope.row.id)"
          >
            修改
          </el-button>
          <!--          <el-button v-if="isAuth('mall:distwithdraw:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">删除</el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
    />
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
      @refreshDataList="getDataList"
    />
  </div>
</template>

<script>
import AddOrUpdate from './distwithdraw-add-or-update';

export default {
  components: {
    AddOrUpdate,
  },
  data() {
    return {
      searchForm: {
        userId: '',
        nickname: '',
        withdrawType: '',
        withdrawAmount: '',
        withdrawFee: '',
        auditStatus: '',
        cardId: '',
        cardNumber: '',
        cardType: '',
        bankName: '',
      },
      confirmAuditForm: {
        id: '',
        auditStatus: '',
        auditDesc: '',
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListSelections: [],
      addOrUpdateVisible: false,
    };
  },
  activated() {
    this.getDataList();
  },
  methods: {
    // 获取数据列表
    getDataList() {
      this.$http({
        url: '/mall/distwithdraw/list',
        method: 'get',
        params: {
          page: this.pageIndex,
          limit: this.pageSize,
          userId: this.searchForm.userId,
          nickname: this.searchForm.nickname,
          withdrawType: this.searchForm.withdrawType,
          withdrawAmount: this.searchForm.withdrawAmount,
          withdrawFee: this.searchForm.withdrawFee,
          auditStatus: this.searchForm.auditStatus,
          cardId: this.searchForm.cardId,
          bankName: this.searchForm.bankName,
        },
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.dataList = data.page.records;
          this.totalPage = data.page.total;
        } else {
          this.dataList = [];
          this.totalPage = 0;
        }
      });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val;
    },
    // 查看详情
    showDetails(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id, true);
      });
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id);
      });
    },
    // 删除
    deleteHandle(id) {
      let ids = id
        ? [id]
        : this.dataListSelections.map((item) => {
            return item.id;
          });
      this.$confirm(`确定对[id=${ids.join(',')}]进行[删除]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$http({
            url: '/mall/distwithdraw/delete',
            method: 'post',
            data: ids,
          }).then(({ data }) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
              });
              this.getDataList();
            }
          });
        })
        .catch(() => {});
    },
    confirmAudit(id, status) {
      this.confirmAuditForm.id = id;
      this.confirmAuditForm.auditStatus = status;
      this.$http({
        url: `/mall/distwithdraw/confirmAudit`,
        method: 'post',
        data: this.confirmAuditForm,
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1500,
          });
          this.getDataList();
        }
      });
    },
  },
};
</script>
